import { bind } from 'bind-decorator';
import type { LinkedNumericValue } from 'bz-core-controls/controls/clinical/clinical-numeric';
import type { ClinicalNumericValue } from 'bz-core-controls/controls/clinical/clinical-numeric';
import Joi from 'joi';

class ClinicalNumericValidatorExtension implements Joi.Extension {
  base = Joi.number();
  type = 'number';

  @bind
  coerce(value: any, state: Joi.State, options: Joi.ValidationOptions) {
    if (this.valueIsScoreValue(value)) {
      return value.value;
    }
    return value;
  }

  @bind
  valueIsScoreValue(val: ClinicalNumericValue): val is LinkedNumericValue {
    return !!val && typeof val === 'object' && val.hasOwnProperty('value');
  }
}

export default ClinicalNumericValidatorExtension;
